import React, { useState } from 'react';
import PropTypes from 'prop-types';
import createSharedReactContext from 'create-shared-react-context';
import { VirtualPaymentGlobalContext } from '../utils/constants';

const GlobalContext = createSharedReactContext({}, VirtualPaymentGlobalContext);

export const GlobalContextProvider = ({ children }) => {
  const [isLogOutDisabled, setLogOutDisabled] = useState(false);

  return (
  // eslint-disable-next-line react/jsx-no-constructed-context-values -- x
    <GlobalContext.Provider value={{ isLogOutDisabled, setLogOutDisabled }}>
      { children }
    </GlobalContext.Provider>
  );
};

GlobalContextProvider.propTypes = {
  children: PropTypes.node,
};
